const groupGetters = {
  getGroupsModel: (state) => state.groupsModel,
  getParentAttributes: (state) => state.parentAttributes,
  getGroups: (state) => state.groups,
  getCustomerGroups: (state) => state.customerGroups,
  getGroup: (state) => state.group,
  getCustomerGroup: (state) => state.customerGroup,
  getParentGroups: (state) => state.parentGroups,
  getInitalParentAttributes: (state) => state.initialParentAttributes,
  getParentAttributesPending: (state) => state.parentAttributesPending
}

export { groupGetters }
